interface Programme {
  [key: string]: any;
}

interface DayProgrammes {
  date: string;
  dayNumber: number;
  programmes: Programme[];
}

export function processProgrammeData(data: Programme[]): DayProgrammes[] {
  const dayMap = new Map<string, DayProgrammes>();

  data.forEach((programme: Programme) => {
    if (!programme.Date)
      return;

    const dateKey = programme.Date; // Already in YYYY-MM-DD format
    const date = new Date(programme.Date);
    const dayNumber = date.getDate();

    if (!dayMap.has(dateKey)) {
      dayMap.set(dateKey, {
        date: dateKey,
        dayNumber,
        programmes: [],
      });
    }

    const dayProgrammes = dayMap.get(dateKey)!;
    dayProgrammes.programmes.push(programme);
  });

  // Sort programmes by time within each day
  dayMap.forEach((dayProgrammes) => {
    dayProgrammes.programmes.sort((a, b) => {
      const timeA = a.Time?.split('-')[0]?.trim() || '00:00';
      const timeB = b.Time?.split('-')[0]?.trim() || '00:00';
      return timeA.localeCompare(timeB);
    });
  });

  // Sort days chronologically
  const sortedDays = Array.from(dayMap.values()).sort((a, b) =>
    new Date(a.date).getTime() - new Date(b.date).getTime(),
  );

  return sortedDays;
}
